import CoreCrossLinks from './CoreCrossLinks';

export { type CoreCrossLinksProps } from './CoreCrossLinks';
export default CoreCrossLinks;
